import { makeOptionsWithNull } from 'Common/FormHelper';

export const IMPORT_INGREDIENT_TYPE_ID = 17;

export const REQUIRED_COLUMNS = [
  'Base Weight',
  'Base Weight Measure',
  'Calories',
  'Name',
  'Saturated Fat',
  'Sodium',
];

export const REQUIRED_COLUMNS_TO_USE_ON_MENUS = REQUIRED_COLUMNS.concat([
  'Meal Category',
  '# of Servings',
  'Serving Size',
  'Serving Unit',
]);

export const UPDATE_KEY_OPTIONS = makeOptionsWithNull(
  [
    { Description: 'Name' },
    { Description: 'Mfr. Product Code' },
    { Description: 'Distributor Code' },
    { Description: 'GTIN/UPC Code' },
  ],
  {
    keyKey: 'Description',
    valueKey: 'Description',
    textKeys: ['Description'],
  }
);



// WEBPACK FOOTER //
// ./src/pages/importingredients/helpers/Constants.js